import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { SynBreadcrumbComponent, SynBreadcrumbItemComponent } from '@synergy-design-system/angular';
import { ClientFormComponent, ClientTemplate } from './client-form.component';
import { Client } from '../../../api/types';
import { ServicePortalApi } from '../../../api/api';
import { emptyClient } from '../../../api/constants';
import { errorMessage, handleError } from '../../../errors';

function toClientTemplate(param: string | null): ClientTemplate {
  switch (param) {
    case 'frontend':
    case 'service':
    case 'custom':
      return param;

    default:
      console.warn('Unexpected value for template:', param);
      return 'custom';
  }
}

@Component({
  selector: 'app-new-client',
  template: `
    <syn-breadcrumb>
      <syn-breadcrumb-item routerLink="" i18n="@@home">Home</syn-breadcrumb-item>
      <syn-breadcrumb-item routerLink="/clients" i18n="@@clients">Clients</syn-breadcrumb-item>
      <syn-breadcrumb-item i18n="@@create-new-client">Create a New Client</syn-breadcrumb-item>
    </syn-breadcrumb>

    <h1 i18n="@@create-new-client">Create a New Client</h1>

    <app-client-form
      [client]="client()"
      [template]="template()"
      submitIcon="add"
      submitText="Create Client" i18n-submitText="@@create-client"
      (submitClient)="onCreate($event)"
    />
  `,
  styles: [
    `
    `,
  ],
  imports: [
    ClientFormComponent,
    RouterLink,
    SynBreadcrumbComponent,
    SynBreadcrumbItemComponent,
  ],
})
export class NewClientComponent implements OnInit {
  route = inject(ActivatedRoute);
  router = inject(Router);
  api = inject(ServicePortalApi);

  client: WritableSignal<Client> = signal(emptyClient());

  template = signal<ClientTemplate>('custom');

  ngOnInit() {
    const templateParam = toClientTemplate(this.route.snapshot.queryParamMap.get('template'));
    this.template.set(templateParam);
    switch (templateParam) {
      case 'frontend':
        this.client.update((value) => {
          value.publicClient = true;
          value.serviceAccountEnabled = false;
          return value;
        });
        break;

      case 'service':
        this.client.update((value) => {
          value.publicClient = false;
          value.serviceAccountEnabled = true;
          return value;
        });
        break;
    }
  }

  onCreate(client: Client) {
    this.api.createClient(client, (newClient) => {
        void this.router.navigate(['clients', newClient.id]);
      },
      (error) => {
        if (error.status === 409) {
          errorMessage.set(
            $localize`:@@error-client-id-already-exists:A client with the same client ID already exists.`,
          );
          window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        } else {
          handleError(error);
        }
      });
  }
}
